import React from "react";
import "./TermsModal.css";

const TermsModal = ({ isOpen, onClose, title, children }) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay-terms">
            <div className="modal-content-terms">
                {/* Modal Header */}
                <div className="modal-header-terms">
                    <h2 className="modal-title-terms">{title}</h2>
                    <button className="modal-close-terms" onClick={onClose}>&times;</button>
                </div>

                {/* Modal Body with PDF Viewer */}
                <div className="modal-body-terms">{children}</div>
            </div>
        </div>
    );
};

export default TermsModal;
